var map = {
	"./Messages.jpg": 357,
	"./Messages.png": 152,
	"./book.png": 153,
	"./box.png": 154,
	"./chat.png": 155,
	"./chat_01.png": 358,
	"./chat_02.png": 359,
	"./chat_icon.png": 360,
	"./cloud.png": 156,
	"./dashboard.png": 361,
	"./dot.png": 362,
	"./get_started_bg.png": 363,
	"./john.png": 157,
	"./left_leaf.png": 158,
	"./live_chat.png": 159,
	"./mobile.png": 160,
	"./panguin_img_one.png": 161,
	"./panguin_img_three.png": 162,
	"./panguin_img_two.png": 163,
	"./pluse.png": 164,
	"./richard.png": 165,
	"./right_leaf.png": 166,
	"./skyp_1.png": 364,
	"./skyp_2.png": 365,
	"./support_dashboard.jpg": 366,
	"./triangle.png": 167,
	"./video_icon.png": 367
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77;